import React, { FC, Fragment } from 'react';
import { PresenterTabsOnMobile } from '../../../constans/presenter-enums';
import './presenter-mobile-navigation.scss';
import { v4 as uuidv4 } from 'uuid';
import PresenterMobileNavigationTab from './presenter-mobile-navigation-tab';
import { observer } from 'mobx-react';
import { useStore } from '../../../store/store-provider';

interface INavigationTabs {
    component: JSX.Element;
}

interface IProps {
    selectedTab: PresenterTabsOnMobile;
    setSelectedTab: (tabName: PresenterTabsOnMobile) => void;
}

interface IMobileHOCProps extends IProps {
  tabName?: PresenterTabsOnMobile;
}


const QuestionPresenterMobileNavigation: FC<IProps> = observer(({ selectedTab, setSelectedTab }) => {
  const { questionStore } = useStore();
  const { getNumberOfQuestionsByMode } = questionStore;

  return (
    <PresenterMobileNavigationTab
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      tabName={PresenterTabsOnMobile.QUESTIONS}
      additionalTabText={`(${getNumberOfQuestionsByMode()})`}
    />
  );
});

const MobileNavigationTabHOC = (Component: React.ElementType, props: IMobileHOCProps) => <Component {...props}/>;

const PresenterMobileNavigation: FC<IProps> = ({ selectedTab, setSelectedTab }): JSX.Element => {

  const navigationTabs: INavigationTabs[] = [
    {
      component: MobileNavigationTabHOC(PresenterMobileNavigationTab, { selectedTab, setSelectedTab, tabName: PresenterTabsOnMobile.CLICKER })
    }, {
      component: MobileNavigationTabHOC(PresenterMobileNavigationTab, { selectedTab, setSelectedTab, tabName: PresenterTabsOnMobile.NOTES }),
    }, {
      component: MobileNavigationTabHOC(QuestionPresenterMobileNavigation, { selectedTab, setSelectedTab }),
    },
  ];

  return (
    <div className="presenter-mobile-navigation">
      {navigationTabs.map(tab => {
        return (
          <Fragment key={uuidv4()}>
            {tab.component}
          </Fragment>
        );
      })}
    </div>
  );
};

export default PresenterMobileNavigation;
